module.exports = __webpack_public_path__ + "static/media/MR.38aef1d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/MR.svg
// module id = 317
// module chunks = 0